import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-80px" }}
            transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-40px" });
    return (
        <span ref={ref} className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block will-change-transform"
                initial={{ y: "112%" }}
                animate={inView ? { y: "0%" } : { y: "112%" }}
                transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function Chapter({ number, label, className = "" }) {
    return (
        <Reveal className={`flex items-center gap-4 ${className}`}>
            <span className="font-mono text-xs text-white/40 tracking-[0.25em]" data-testid={`chapter-${number}`}>
                {number}
            </span>
            <span className="h-px w-12 bg-white/20" />
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-white/60">{label}</span>
        </Reveal>
    );
}

export function SectionHead({ number, label, title, copy, align = "left" }) {
    return (
        <div className={align === "center" ? "text-center" : ""}>
            <Chapter number={number} label={label} className={align === "center" ? "justify-center" : ""} />
            <Reveal delay={0.1}>
                <h2 className="mt-8 font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[0.95] text-white text-balance">
                    {title}
                </h2>
            </Reveal>
            {copy && (
                <Reveal delay={0.2}>
                    <p className={`mt-6 max-w-2xl text-base md:text-lg font-light leading-relaxed text-white/60 ${align === "center" ? "mx-auto" : ""}`}>
                        {copy}
                    </p>
                </Reveal>
            )}
        </div>
    );
}
